import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import DriverCard from './../../driver-card/DriverCard';
import { waypointPropTypes, customizationsPropTypes, orderPropTypes } from '../../../../utils/prop-types';
import { Container } from './styles';
import Address from '../../address';

export default class OrderCardBody extends PureComponent {
  static propTypes = {
    quiqee: PropTypes.shape({
      img: PropTypes.string,
      name: PropTypes.string,
      transportMode: PropTypes.string,
      phone: PropTypes.string,
    }).isRequired,
    waypoint: waypointPropTypes.isRequired,
    customizations: customizationsPropTypes,
    jobState: orderPropTypes.string,
  };

  static defaultProps = {
    customizations: {},
    jobState: '',
  };

  render() {
    const { quiqee, waypoint, customizations, jobState } = this.props;

    return (
      <Container>
        <Address type={waypoint.waypointType} location={waypoint.location} />
        <DriverCard quiqee={quiqee} showPhone={!customizations.hideCourierNumber} jobState={jobState} />
      </Container>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/order-card/pending/body/OrderCardBody.js